// extracted by mini-css-extract-plugin
export default {"add_stylist_container":"AddStylist_add_stylist_container__tmbaq","add_stylist":"AddStylist_add_stylist__aKKw3","stylist_item":"AddStylist_stylist_item__tyV83"};